import {BaseCachedService} from './Core/BaseCachedService';

class TaxLotService extends BaseCachedService {
    get Url() { return super.Url + "/taxLots"; }
    get ModelName() { return "TaxLot"; }
    get PrimaryKeyProperty() { return "taxLotId"; }
    get TitleProperty() { return "parcelNumber"; }
}

export const service = new TaxLotService();

